

export { CBottomFooterLinks } from '../../fragments/c-bottom-footer-links'
